import { render, staticRenderFns } from "./PdpFrOnly.vue?vue&type=template&id=5eb53ac5&scoped=true"
import script from "./PdpFrOnly.vue?vue&type=script&lang=js"
export * from "./PdpFrOnly.vue?vue&type=script&lang=js"
import style0 from "./PdpFrOnly.vue?vue&type=style&index=0&id=5eb53ac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb53ac5",
  null
  
)

export default component.exports